export default __webpack_public_path__ + "static/media/pic9.3c4a099a.jpg";